import { takeLatest, put } from 'redux-saga/effects';
import { OK } from 'http-status-codes';
import api from './api';
import { mapToOptionById } from '../../utils/api';
import { types, actions } from './duck';

export function* getCouponRangeList() {
  try {
    yield put(actions.getCouponRangeListRequest());

    const response = yield api.getCouponRangeList();

    if (response.status === OK) {
      const couponRangeOptions = mapToOptionById(response.data);
      yield put(actions.getCouponRangeListSuccess(couponRangeOptions));
    } else {
      throw Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCouponRangeListFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.GET_COUPON_RANGE_LIST, getCouponRangeList);
}
